export default __webpack_public_path__ + "static/media/hero-video.5b0a765d.mp4";